/**
 * @module app.pp
 */

import { autoinject } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { RouteConfig, NavigationInstruction } from 'aurelia-router';
import { I18N } from 'aurelia-i18n';
import { apiCall } from 'app/shared/lib/api/api';
import { MemberService } from 'app/cd/services/member-service';
import * as PP from 'app/pp/models/essette-api';


@autoinject()
export class PatientSummaryPage extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    protected member: PP.AvailableMember | null = null;


    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly service: MemberService,
        private readonly i18n: I18N,
        ...rest: any[]) {

        super(...rest);
        this.logger.source = this;
    }

    protected async canActivate(params: any, routeConfig: RouteConfig, navInstruction: NavigationInstruction): Promise<boolean> {
        await this.accountContext.load();
        return this.accountContext.hasRouteAccess('pp.patient.summary');
    }


    protected async activate(params: { memberId: string, planId: string }, routeConfig: RouteConfig, navInstruction: NavigationInstruction): Promise<void> {
        if(!params?.memberId) {
            throw new Error('Missing required parameter: memberId');
        }

        await this.reload(params.memberId);

        if(this.member && routeConfig.navModel) {
            const title = this.i18n.tr('pp:routes.member.summary.$title', { display: this.member?.$display });
            routeConfig.navModel.setTitle(title);
        }
    }


    ////****************** Events ***************************************************////
    public async reload(memberId: string): Promise<void> {
        if(memberId) {
            await this.loadMember(memberId);
        }
    }


    ////****************** Functions ************************************************////


    ////****************** Service Calls ********************************************////
    @apiCall
    private async loadMember(memberId: string): Promise<void> {
        if(!memberId) return;

        const includes: string[] = [];
        const fields: string[] = ['description'];

        try {
            this.state.beginLoad();

            const response = await this.service.loadPatient(memberId, includes, fields);
            this.member = response.results[0];
        } catch(error) {
            throw error;
        } finally {
            this.state.endLoad();
        }
    }
}
